// extracted by mini-css-extract-plugin
module.exports = {"fadingCircle":"fading-circle-view_fadingCircle__3yBsd","circle":"fading-circle-view_circle__3-djQ"};